@if(salesOrder) {
  <div class="col-span-2 bg-white rounded-lg  flex p-6 gap-6">
    <div>{{ salesOrder.salesOrderReference }}</div>
    <div>{{ salesOrder.customer.customerName }}</div>
    <div>{{ salesOrder.poDate }}</div>
    <div>{{ salesOrder.poNumber }}</div>
    <div>{{ salesOrder.poValue }}</div>
  </div>
}
